import { render } from "./CustomTooltip.vue?vue&type=template&id=08c67c22"
import script from "./CustomTooltip.vue?vue&type=script&lang=js"
export * from "./CustomTooltip.vue?vue&type=script&lang=js"

import "./CustomTooltip.vue?vue&type=style&index=0&id=08c67c22&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__